import Crud from '../views/Professional/Crud'
import Entity from '../views/Professional/Add'

let routes = {
    path: '/professionals',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/professionals/add',
            name: 'NewProfessional',
            component: Entity,
            meta: {
                pageTitle: 'professional.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'professional.form.newTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/professionals/edit/:id?',
            name: 'EditProfessional',
            component: Entity,
            meta: {
                pageTitle: 'professional.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'professional.form.editTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/professionals',
            name: 'list-professionals',
            component: Crud,
            meta: {
                pageTitle: 'professional.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'professional.crud.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
